{
	"breadcrumbs": "Kruimelpad",
	"title": "Voor je {{holder}}",
	"title_doek": "Doekjes voor de {{holder}}",
	"title_navulling": "Navullingen voor je {{holder}}",
	"pieces": "stuks",
	"pieces_doek": "doekjes",
	"pieces_navulling": "navullingen",
	"lead": {
		"from": "Vanaf",
		"perPiece": "per {{noun}}",
		"inPack": "in het pak van {{count}}"
	},
	"fit": {
		"title": "Wat erop past",
		"summary": "Past op je {{holder}}.",
		"summaryWithSize": "Past op je {{holder}} ({{size}}).",
		"yours": "Past op je {{holder}}",
		"other": "Past op {{holder}}",
		"notFor": "Niet voor {{holder}}",
		"notForOne": "Niet voor de {{holder}}",
		"notForSummary": "{{text}}.",
		"unconfirmedOthers": "andere wissers",
		"footSize": "Voetmaat: {{size}}",
		"measuringTip": "Meettip.",
		"more": "Meer",
		"less": "Minder"
	},
	"diagram": {
		"cloth": "doekje, plat",
		"foot": "voet van de wisser",
		"fold": "vouwlijn"
	},
	"packs": {
		"title": "Kies je pak",
		"count_one": "{{count}} pak",
		"count_other": "{{count}} pakken",
		"order": {
			"pricePerPiece": "goedkoopste per {{noun}} eerst",
			"price": "laagste prijs eerst",
			"popular": "meest gekocht eerst"
		},
		"sort": {
			"label": "Sorteer",
			"pricePerPiece": "Prijs per {{noun}}",
			"price": "Prijs",
			"popular": "Populariteit"
		},
		"soldOutLast": "Een uitverkocht pak staat altijd onderaan.",
		"empty": "Er zijn nu geen pakken voor de {{holder}}. Kijk later nog eens, of neem contact op."
	},
	"others": {
		"title": "De {{holder}}",
		"title_navulling": "Het {{holder}}",
		"intro": "Nog geen {{holder}}? Begin hier. Daarna bestel je alleen nog {{pieces}}.",
		"fit": "Voor {{pieces}} {{size}}"
	},
	"faq": {
		"title": "Vragen over {{group}}",
		"all": "Alle veelgestelde vragen"
	}
}
